/* eslint-disable strict */

'use strict';

/**
 * Update product variant pricing.
 * Can be triggered by multiple events:
 *   'cart:change' event triggered by AjaxCart
 *   'change' event triggered by product variant form <select>
 *   'change' event triggered by buy bar <select>
 */
(async function VariantSelect() {
  var manualPriceUpdateAndEmit = Simba.Functional.compose(emitVariantChange, productFormMDVupdate, eventData);
  var productFormMDV = Simba.ModelDrivenView.init($('[data-mdv-product-form]'));
  var $variantSelect = $('[data-product-form] [data-variant-select]');

  document.addEventListener('cart:change', priceUpdateAndEmit, false);
  document.addEventListener('bed-configurator:change', priceUpdateAndEmit, false);
  document.addEventListener('bed-configurator:complete', priceUpdateAndEmit, false);

  document.addEventListener('simple-bed-variant:update', manualPriceUpdateAndEmit, false);

  $variantSelect.on('change', priceUpdateAndEmit);

  // PK I think this can be delteted
  // window.SimbaTiered = window.SimbaTiered || {};
  // window.SimbaTiered.priceUpdate = priceUpdateAndEmit;

  await priceUpdateAndEmit();

  async function priceUpdateAndEmit() {
    const variant = await collateData().variant;
    if (typeof variant !== 'undefined') {
      const updateObject = {
        variant: variant
      };
      const data = productFormMDVupdate(updateObject);
      emitVariantChange(data);
    }
  }

  function productFormMDVupdate(data) {
    var variant = data.variant;
    var financeInstalmentValue = 0;
    var variantEligibleForFinance = false;
    if (typeof variant !== 'object') return data;

    if (Simba.FinanceCalculator.length > 0) {
      if (variant.finance.price >= Simba.FinanceCalculator[0].instalment12Threshold) {
        financeInstalmentValue = variant.finance.lowestInstalmentPriceFormatted;
        variantEligibleForFinance = true;
      } else if (variant.finance.price >= Simba.FinanceCalculator[0].financeThreshold) {
        /**
         * instalmentPriceFormatted Array:
         *  3 Months
         *  6 Months
         *  12 Months
         */
        financeInstalmentValue = variant.finance.instalmentPriceFormatted[2];
        variantEligibleForFinance = true;
      }
    }

    // START: CRO SIM-3592 START
    const $variantTitle = document.querySelector('[data-variant-title]');
    if ($variantTitle) {
      $variantTitle.innerHTML = variant.variantTitle.split(':')[0].split(' / ')[0];
    }
    // END: CRO SIM-3592 END

    // Update the view
    productFormMDV.setPrice = variant.priceFormattedWithoutTrailingZeros;
    productFormMDV.setOriginalPrice = variant.originalPriceFormattedWithoutTrailingZeros;
    productFormMDV.setHasDiscount = variant.hasDiscount;
    productFormMDV.setNotHasDiscount = !variant.hasDiscount;
    productFormMDV.setSavingTotal = variant.savingTotal;
    productFormMDV.setCompareAtSavingTotal = variant.compareAtSavingTotal;
    productFormMDV.setDiscountPercent = variant.discountPercentage.standard;
    productFormMDV.setDiscountPercentBase = variant.discountPercentage.base;
    productFormMDV.setBaseSavingTotal = variant.baseSavingTotal;
    productFormMDV.setHasCompareAtPrice = variant.hasCompareAtPrice;
    productFormMDV.setCompareAtPrice = variant.compareAtPrice;
    productFormMDV.setHasFinance = variant.hasFinance && variantEligibleForFinance;
    productFormMDV.setInstalmentPrice = financeInstalmentValue;
    productFormMDV.setInstalmentMonths = variant.finance.instalmentMonths;
    productFormMDV.setEcoTax = variant.ecoTax;
    if (variant.external) productFormMDV.setAtcExternalURL = variant.external;

    return data;
  }

  /**
   * Get variant data from variantSelect selected value.
   * @return {object} data required for price update sequence.
   */
  function collateData() {
    var variantId = $variantSelect.find(':selected').is(':disabled') ? $variantSelect.prop('value') : $variantSelect.val();

    return {
      variant: Simba.ProductAsync.load(variantId)
    };
  }

  /**
   * Get variant data from event
   *  {
   *     variant: Simba.Product[variantId]
   *  }
   * @return {object} data required for price update sequence.
   */
  function eventData(evt) {
    return evt.detail;
  }

  /**
   * Emit 'variant:change' event.
   * @param {object} data collateData output.
   */
  function emitVariantChange(data) {
    if (typeof window.Simba.MattressPricePopulate === 'function') {
      window.Simba.MattressPricePopulate();
    }
    Simba.Event.emit('variant:change', data);
  }
})();

/**
 * Product select.
 * Only for mattress product.
 */
(function ProductSelect() {
  var $productSelect = $('[data-product-form] [data-product-select]');
  if ($productSelect.length) {
    $productSelect.on('change', function () {
      var $this = $(this);
      var handle = $this.val();
      window.location = '/products/' + handle;
    });
  }
})();

/**
 * Product EADD.
 *
 * Show or hide the EADD message on PDPs based on selected variant.
 */
(function EADD() {
  const earliestDeliveryMessages = document.querySelectorAll('[data-earliest-message]');
  const deliveryMessages = document.querySelectorAll('[data-delivery-message]');

  document.addEventListener('variant:change', updateEADD, false);

  function updateEADD(event) {
    const variant = event.detail.variant;
    const currentMessage = getMessage(variant?.id);

    removeProps();

    if (typeof variant !== 'object') {
      return;
    }

    hideMessages(earliestDeliveryMessages, true);

    if (currentMessage !== null && currentMessage !== 'undefined') {
      currentMessage.classList.remove('hidden');

      if (currentMessage.hasAttribute('data-hide-delivery')) {
        hideMessages(deliveryMessages, true);
      }

      addProps(variant.id);
    } else {
      hideMessages(deliveryMessages, false);
    }
  }

  /**
   * Hide or show the supplied messages.
   *
   * @param {NodeList} messages
   * @param {Boolean} hide
   */
  function hideMessages(messages, hide) {
    messages.forEach((message) => {
      if (hide) {
        message.classList.add('hidden');
      } else {
        message.classList.remove('hidden');
      }
    });
  }

  /**
   * Get the EADD message for the variant.
   *
   * @param {Number} variantId
   * @return {Element}
   */
  function getMessage(variantId) {
    return document.querySelector('[data-earliest-message="' + variantId + '"]');
  }

  /**
   * Add the necessary line item properties.
   *
   * @param {Number} variantId
   */
  function addProps(variantId) {
    const prop = buildProp(variantId);
    document.querySelectorAll('[data-product-line-properties]').forEach((properties) => {
      properties.appendChild(prop);
    });
  }

  /**
   * Remove any EADD line item properties.
   */
  function removeProps() {
    document.querySelectorAll('.eddHiddenProp').forEach((prop) => prop.remove());
  }

  /**
   * Build a EADD line item property element.
   *
   * @param {Number} variantId
   * @return {HTMLInputElement}
   */
  function buildProp(variantId) {
    return Object.assign(document.createElement('input'), {
      type: 'hidden',
      name: 'properties[EADD]',
      value: variantId,
      className: 'eddHiddenProp'
    });
  }
})();
